/* product read more 
$(document).ready(function () {
  var $description = $('.product-info__block-item[data-block-id="description"] .prose');

  if ($description.length === 0) return;
  if ($(window).width() > 768) return; // Only apply on mobile

  var maxHeight = 78; // px

  if ($description[0].scrollHeight > maxHeight) {
    $description.addClass('truncated-description');

    var $btn = $('<button/>', {
      text: '... Voir plus',
      class: 'read-more-toggle'
    });

    $description.parent().append($btn);

    $btn.on('click', function () {
      $description.toggleClass('open');
      $btn.toggleClass('open');

      var isOpen = $description.hasClass('open');
      $btn.text(isOpen ? 'Voir moins' : '... Voir plus');
    });
  }
});
*/

/* Cart drawer discount code — AJAX apply via cart-discount-field web component (dispatches cart:refresh, no reload) */
function submitCartDrawerDiscount(input) {
  if (!input || !input.value.trim()) return;
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

document.addEventListener('click', function (e) {
  const button = e.target.closest('[data-action="apply-discount"]');
  if (!button) return;
  submitCartDrawerDiscount(button.closest('cart-discount-field')?.querySelector('.cart-drawer__discount-input'));
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter') return;
  const input = e.target.closest('cart-discount-field .cart-drawer__discount-input');
  if (!input) return;

  e.preventDefault();
  submitCartDrawerDiscount(input);
});

/* Clear the input when the applied code turns out to be invalid */
document.addEventListener('cart:discount:error', function (e) {
  const field = e.target;
  if (!field || field.tagName !== 'CART-DISCOUNT-FIELD') return;
  const input = field.querySelector('.cart-drawer__discount-input');
  if (input) input.value = '';
});

/*
  Cart drawer quantity +/- : guard against duplicate/overlapping requests.

  Each click on the +/- links (rendered by snippets/_hover-quantity-selector.liquid as
  `<a href="/cart/change?...">`) is handled by the theme's own <line-item-quantity> component
  (assets/theme.js), which fires one cart/change.js request per click with no debounce and re-renders
  the whole cart drawer section on every response. Two consequences when a customer clicks fast
  (which they do, since that re-render makes the drawer feel slow to react):
    1. Duplicate requests queue up instead of the UI just waiting for the first one.
    2. The link's target quantity is computed at render time, so a second click fired before the
       first request's re-render lands can resend the SAME target quantity instead of the next one.
  We don't touch the actual request/response/error-handling logic (still entirely theme.js's), we
  only block re-entrant clicks on a line item while its own request is in flight, using the same
  aria-busy="true" convention already used elsewhere in the theme (see theme.css / theme.js).
*/
document.addEventListener('click', function (e) {
  const link = e.target.closest('.cart-drawer line-item-quantity a[href*="/cart/change"]');
  if (!link) return;

  const wrapper = link.closest('line-item-quantity');
  if (!wrapper) return;

  if (wrapper.getAttribute('aria-busy') === 'true') {
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  wrapper.setAttribute('aria-busy', 'true');
  /* Safety net: theme.js only clears loading state after `await fetch(...)` resolves, so a
     network failure (offline, timeout) would leave this guard stuck forever. Force-clear it. */
  setTimeout(function () { wrapper.removeAttribute('aria-busy'); }, 8000);
}, true);

document.addEventListener('theme:loading:end', function () {
  document.querySelectorAll('.cart-drawer line-item-quantity[aria-busy="true"]').forEach(function (wrapper) {
    wrapper.removeAttribute('aria-busy');
  });
});

/* Meganav innver menu desktop */
document.querySelectorAll('.mega-menu').forEach(menu => {

  const selects = menu.querySelectorAll('.megaNavSelect');
  const boxes = menu.querySelectorAll('.megaNavInnerBox');

  selects.forEach(item => {

    item.addEventListener('mouseenter', function() {

      const index = this.getAttribute('is-item');

      // remove active from THIS menu only
      selects.forEach(el => el.classList.remove('active'));
      boxes.forEach(el => el.classList.remove('active'));

      // activate hovered selector
      this.classList.add('active');

      // activate matching content INSIDE THIS MENU ONLY
      const target = menu.querySelector('.megaNavInnerBox[is-item="' + index + '"]');
      if (target) {
        target.classList.add('active');
      }

    });

  });

});
/* accordion toggle */
$(document).ready(function () {
  $('.accordion__disclosure, .accordion__box').on('toggle', function () {
    const $this = $(this);

    if ($this.prop('open')) {
      // Close all other accordions of same type
      $(this.tagName)
      $(this).closest('body').find(this.className.split(' ')[0])

      $(this).siblings('.' + this.className.split(' ')[0])

      $(`.${this.className.split(' ')[0]}`).not(this).each(function () {
        $(this).removeAttr('open').attr('aria-expanded', 'false');
      });

      // Set this one as expanded
      $this.attr('aria-expanded', 'true');
    } else {
      $this.attr('aria-expanded', 'false');
    }
  });
});

/*
  // Function to initialize Trustpilot widget on a given element
  function initTrustpilot() {
    var widget = document.getElementById('tttrustpilot-widget');
    if (widget && window.Trustpilot) {
      window.Trustpilot.loadFromElement(widget);
    }
  }

  // Initialize on first page load
  document.addEventListener('DOMContentLoaded', initTrustpilot);

  // Example: reinitialize after variant change via AJAX
  // Replace this with your actual variant change callback
  document.addEventListener('variantChange', function(e) {
    // Update SKU dynamically
    var newSku = e.detail.sku; // pass the new SKU in your event
    var widget = document.getElementById('tttrustpilot-widget');
    if (widget) {
      widget.setAttribute('data-sku', 'BRUM15');
      // Re-load Trustpilot widget
      window.Trustpilot.loadFromElement(widget);
    }
  });

*/

/* table of content articles */
$(document).ready(function() {

  const $toc = $("#toc");
  const $content = $(".articleBody");

  if (!$toc.length || !$content.length) return;

  const $headings = $content.find("h1, h2, h3");
  if (!$headings.length) return;

  $headings.each(function(index) {
    const $heading = $(this);
    const text = $heading.text().trim();
    if (!text) return;

    let id = $heading.attr("id");
    if (!id) {
      id = `heading-${index}`;
      $heading.attr("id", id);
    }

    const level = parseInt($heading.prop("tagName").substring(1));

    const $listItem = $("<li>")
      .addClass(`toc-level-${level}`)
      .append(`<a href="#${id}">${text}</a>`);

    $toc.append($listItem);
  });

});
/* Media grid: mobile slider (section "media-grid" with "Stack blocks on mobile" disabled).
   Swiper only runs below 700px, the desktop keeps the grid layout of the theme. */
class MediaGridSlider extends HTMLElement {
  connectedCallback() {
    this.mediaQuery = window.matchMedia('(max-width: 699px)');
    this.onMediaChange = this.update.bind(this);
    this.mediaQuery.addEventListener('change', this.onMediaChange);
    this.update();
  }

  disconnectedCallback() {
    this.mediaQuery.removeEventListener('change', this.onMediaChange);
    this.destroySwiper();
  }

  update() {
    if (this.mediaQuery.matches) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  initSwiper() {
    if (this.swiper || typeof Swiper === 'undefined') return;

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1.33, // one block is about 75% of the width, the next one peeks on the right
      spaceBetween: parseInt(this.getAttribute('space-between'), 10) || 0,
      speed: 500,
      navigation: {
        prevEl: this.querySelector('.media-grid-slider__prev'),
        nextEl: this.querySelector('.media-grid-slider__next'),
      },
      pagination: {
        el: this.querySelector('.media-grid-slider__progress'),
        type: 'progressbar',
      },
    });
  }

  destroySwiper() {
    if (!this.swiper) return;

    this.swiper.destroy(true, true);
    this.swiper = null;
  }
}

if (!window.customElements.get('media-grid-slider')) {
  window.customElements.define('media-grid-slider', MediaGridSlider);
}

/*
 * Carousel tracker: progress bar for a theme scroll-carousel (referenced by aria-controls), used by the featured
 * collections section when "Show slider tracker" is enabled. Fills with the visible part of the carousel, so it
 * starts partially filled and reaches the end on the last products, like the media grid Swiper progress bar.
 */
class CarouselTracker extends HTMLElement {
  connectedCallback() {
    this.carousel = document.getElementById(this.getAttribute('aria-controls'));
    this.fill = this.querySelector('.carousel-tracker__fill');
    if (!this.carousel || !this.fill) return;

    this.abortController = new AbortController();
    this.update = this.update.bind(this);
    this.carousel.addEventListener('scroll', this.update, { passive: true, signal: this.abortController.signal });
    window.addEventListener('resize', this.update, { signal: this.abortController.signal });
    this.update();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  update() {
    const { scrollWidth, clientWidth } = this.carousel;
    const scrollLeft = Math.abs(this.carousel.scrollLeft); // negative in RTL
    const progress = scrollWidth > clientWidth ? Math.min(1, (scrollLeft + clientWidth) / scrollWidth) : 1;

    this.fill.style.transform = `scaleX(${progress})`;
  }
}

if (!window.customElements.get('carousel-tracker')) {
  window.customElements.define('carousel-tracker', CarouselTracker);
}

/*
 * Image slider with text (section "image-slider-with-text"): Swiper on the image, the "thumbnails" block in the content
 * changes the slide. In the theme editor, selecting a slide block shows that slide.
 */
class ImageSliderWithText extends HTMLElement {
  connectedCallback() {
    const swiperElement = this.querySelector('.swiper');
    if (!swiperElement || typeof Swiper === 'undefined') return;

    this.thumbnails = Array.from(this.querySelectorAll('.image-slider-with-text__thumbnail'));
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      speed: 500,
      navigation: {
        prevEl: this.querySelector('.image-slider-with-text__prev'),
        nextEl: this.querySelector('.image-slider-with-text__next'),
      },
      on: {
        slideChange: () => this.updateThumbnails(),
      },
    });

    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => this.swiper.slideTo(Number(thumbnail.dataset.index)), { signal });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest?.('.image-slider-with-text__slide');
      if (slide && this.contains(slide)) this.swiper.slideTo(Number(slide.dataset.slideIndex), 0);
    }, { signal });

    this.updateThumbnails();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }

  updateThumbnails() {
    this.thumbnails.forEach((thumbnail) => {
      const isActive = Number(thumbnail.dataset.index) === this.swiper.activeIndex;
      thumbnail.classList.toggle('is-active', isActive);
      thumbnail.toggleAttribute('aria-current', isActive);
    });
  }
}

if (!window.customElements.get('image-slider-with-text')) {
  window.customElements.define('image-slider-with-text', ImageSliderWithText);
}
